import React, { useEffect, useMemo, useRef, useState } from "react";
import "./SelectTime.css";
import { isChildElement } from "../../utils/isChildElement";
import { cycleArr } from "../../utils/cycles";

const TRACKPAD_STEP_SIZE = 30; // px to accumulate for one step (smooth trackpad)
const MOUSE_NOTCH_THRESHOLD = 50; // deltaY >= this → physical mouse wheel notch

export const SelectValueList = ({values, selectedIndex, onSelect, onSameValueClick}: {values: Array<string>, selectedIndex: number, onSelect: (index: number, value: string)=>void, onSameValueClick: ()=>void})=>{
    const [position, setPosition] = useState<number>();
    const [isActive, setActive] = useState(false);
    const shownItems = useMemo(()=>new Array(7).fill(0).map((it, i)=> cycleArr(i+position-3, values)), [position]);
    const accumulatedDeltaRef = useRef(0);

    useEffect(()=>{
        setPosition(selectedIndex);
    }, [selectedIndex, values]);

    const handleWheel = (e: React.WheelEvent<HTMLDivElement>)=>{
        if (!e.deltaY) return;
        let steps: number;
        if (Math.abs(e.deltaY) >= MOUSE_NOTCH_THRESHOLD) {
            // Physical mouse wheel — one notch = exactly one step
            accumulatedDeltaRef.current = 0;
            steps = Math.sign(e.deltaY);
        } else {
            // Smooth trackpad — accumulate small deltas
            accumulatedDeltaRef.current += e.deltaY;
            steps = Math.trunc(accumulatedDeltaRef.current / TRACKPAD_STEP_SIZE);
            if (steps !== 0) accumulatedDeltaRef.current -= steps * TRACKPAD_STEP_SIZE;
        }
        if (steps !== 0) setPosition(last => (last ?? selectedIndex) + steps);
    }

    useEffect(()=>{
        onSelect(position ?? selectedIndex, cycleArr(position ?? selectedIndex, values));
    }, [position]);

    return (
        <div className="commonSelectTime_scrollList_collapser" 
            onWheel={handleWheel}
            onMouseMove={(e)=>setActive(true)}
            onMouseLeave={()=>setActive(false)}
        >
            {shownItems.map((it, i)=><div className="commonSelectTime_scrollList_item" onClick={(e)=>{setPosition(last=>last+i - 3); if(i==3){onSameValueClick()}}}>{it}</div>)}
        </div>
    )
}

interface ISelectMultiValuesProps {
    values: Array<Array<string>>;
    onSelect: (indexes: number[])=>void;
    selectedIndexes: number[];
    defaultOpen?: boolean;
}

export const SelectMultiValues = ({values, selectedIndexes, onSelect, defaultOpen}: ISelectMultiValuesProps)=>{
    const [isOpen, setIsOpen] = useState(defaultOpen ?? false);
    const dropDownRef = useRef<HTMLDivElement>(null);
    const [isActive, setActive] = useState(false);
    const [selectedIndexList, setSelectedIndexList] = useState<Array<number>>(selectedIndexes);
    
    useEffect(()=>{
        setSelectedIndexList(selectedIndexes);
    }, [selectedIndexes]);

    useEffect(()=>{
        if (isOpen == false){
            onSelect(selectedIndexList)
        }
    }, [selectedIndexList, isOpen]);

    useEffect(()=>{
        const windowHandler = (e: MouseEvent)=>{
            if (!isChildElement(e.target as HTMLElement, dropDownRef.current)){
                setIsOpen(false);
            }
        }
        window.addEventListener('click', windowHandler);
        return ()=>{
            window.removeEventListener('click', windowHandler);
        }
    }, []);

    useEffect(()=>{
        console.log('sc');
        const h = ((e:any)=>{
            if (isActive){
                e.preventDefault();
            } else {
                setIsOpen(false);
            }
        });

        window.document.documentElement.addEventListener('wheel', h, {passive: false});
        return ()=>{
            window.document.documentElement.removeEventListener('wheel', h); 
        }
    }, [isActive]);

    return <div ref={dropDownRef} className={`commonSelectTime ${isOpen ? '' : 'commonSelectTime--collapsed'}`} 
            onMouseMove={(e)=>setActive(true)}
            onMouseLeave={()=>setActive(false)}
            onClick={()=>{if (isOpen == false) {setIsOpen(true)}}}
        >
        <div className="commonSelectTime_scrollList">
            <div className="commonSelectTime_scrollList_items">
                {values.map((it, vi)=><SelectValueList onSameValueClick={()=>{setIsOpen(false);}} values={it} selectedIndex={selectedIndexList[vi] || selectedIndexes[vi] || 0 } onSelect={(i, v)=>{console.log('selected ', i, v); setSelectedIndexList(last=>{const next = [...last]; next[vi] = i; return next})}}></SelectValueList>)}
            </div>
        </div>
        <div className="commonSelectTime_selectionBorder" style={{pointerEvents: "none"}}>

        </div>
    </div>
}

interface ISelectTimeProps{
    onSelect: (date: Date)=>void;
    selectedDate: Date;
    defaultOpen?: boolean;
}

export const SelectTime = ({onSelect, selectedDate, defaultOpen} : ISelectTimeProps)=>{
    const [selected, setSelected] = useState<number[]>([3, 14]);

    useEffect(()=>{
        setSelected([
            selectedDate.getHours(),
            selectedDate.getMinutes()
        ]);
    }, [selectedDate]);

    const hours = new Array(24).fill(0).map((it, i)=>i<10 ? '0'+i : i.toString());
    const minutes = new Array(60).fill(0).map((it, i)=>i<10 ? '0'+i : i.toString());
    return <SelectMultiValues selectedIndexes={selected} onSelect={(d)=>{
        if (selected.join(', ') != d.join(', ')){
            setSelected(last=> [...d]); 
            console.log(d);
            const hoursValue = Number(cycleArr(d[0], hours));
            const minutesValue = Number(cycleArr(d[1], minutes));
            const newDate = new Date(selectedDate);
            newDate.setMinutes(minutesValue);
            newDate.setHours(hoursValue)
            onSelect(newDate);
        }
    }}
        values={[hours, minutes]}
        defaultOpen={defaultOpen}
    ></SelectMultiValues>
}

export const SelectTimeOld = ({}: ISelectTimeProps)=>{
    const values = [''];
    const [position, setPosition] = useState(0);
    const [scrollPosition, setScrollPosition] = useState(0);
    const [isActive, setActive] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const shownItems = useMemo(()=>new Array(7).fill(0).map((it, i)=> cycleArr(i+position-3, values)), [position]);
    const dropDownRef = useRef<HTMLDivElement>(null);

    useEffect(()=>{
        const diffPosition = scrollPosition / 10 - position;
        if (Math.abs(diffPosition) > 1){
            setPosition(last=> last+Math.floor(Math.abs(diffPosition)) * Math.sign(diffPosition));
        }
    }, [scrollPosition]);

    useEffect(()=>{
        console.log('sc');
        const h = ((e:any)=>{
            if (isActive){
                e.preventDefault();
            } else {
                setIsOpen(false);
            }
        });

        window.document.documentElement.addEventListener('wheel', h, {passive: false});
        return ()=>{
            window.document.documentElement.removeEventListener('wheel', h); 
        }
    }, [isActive]);

    useEffect(()=>{
        const windowHandler = (e: MouseEvent)=>{
            if (!isChildElement(e.target as HTMLElement, dropDownRef.current)){
                setIsOpen(false);
            }
        }
        window.addEventListener('click', windowHandler);
        return ()=>{
            window.removeEventListener('click', windowHandler);
        }
    }, []);

    const handleWheel = (e: React.WheelEvent<HTMLDivElement>)=>{
        setScrollPosition(last=>last+=e.deltaY);     
    }

    return <div ref={dropDownRef} className={`commonSelectTime ${isOpen ? '' : 'commonSelectTime--collapsed'}`} 
            onWheel={handleWheel}
            onMouseMove={(e)=>setActive(true)}
            onMouseLeave={()=>setActive(false)}
            onClick={()=>{setIsOpen(true)}}
        >
        <div className="commonSelectTime_scrollList">
            <div className="commonSelectTime_scrollList_items">
                <div className="commonSelectTime_scrollList_collapser">
                    {shownItems.map((it, i)=><div className="commonSelectTime_scrollList_item" onClick={()=>setPosition(last=>last+i - 3)}>{it}</div>)}
                </div>
            </div>
        </div>
        <div className="commonSelectTime_selectionBorder">

        </div>
    </div>
}